import { render, staticRenderFns } from "./USearch.vue?vue&type=template&id=3a561b68&scoped=true&"
import script from "./USearch.vue?vue&type=script&lang=js&"
export * from "./USearch.vue?vue&type=script&lang=js&"
import style0 from "./USearch.vue?vue&type=style&index=0&id=3a561b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a561b68",
  null
  
)

export default component.exports